function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
/**
 * Arcade Settings overlay — short informational panel with Store / Wiki links.
 */
var SettingsOverlayTemplate = require('./settings_overlay.template');
var SaitoOverlay = require('../../../../lib/saito/ui/saito-overlay/saito-overlay');
var SettingsOverlay = /*#__PURE__*/function () {
  function SettingsOverlay(app) {
    var mod = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    _classCallCheck(this, SettingsOverlay);
    this.app = app;
    this.mod = mod;
    this.overlay = new SaitoOverlay(app, mod);
  }
  return _createClass(SettingsOverlay, [{
    key: "render",
    value: function render() {
      this.overlay.show(SettingsOverlayTemplate());
      this.attachEvents();
    }
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      var _this = this;
      var root = document.querySelector('.arcade-settings');
      if (!root) {
        return;
      }
      var store = root.querySelector('[data-action="store"]');
      if (store) {
        store.onclick = function (e) {
          e.preventDefault();
          if (_this.app.modules.returnModule('Store')) {
            _this.overlay.remove();
            navigateWindow('/store', 200);
          } else {
            siteMessage('The Saito Store is not available on this node.', 3000);
          }
        };
      }
      var wiki = root.querySelector('[data-action="wiki"]');
      if (wiki) {
        wiki.onclick = function (e) {
          e.preventDefault();
          window.open('https://wiki.saito.io', '_blank', 'noopener,noreferrer');
        };
      }
    }
  }]);
}();
module.exports = SettingsOverlay;